import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

import { StyledTableHeadingCell } from "../../../../../common/components/functional/simpleTable/styled";

export const ManualSalaryHeader = () => {
  const { t } = useTranslation("talentProfile");
  return (
    <TableRow>
      <StyledTableHeadingCell width="8%">{t("type")}</StyledTableHeadingCell>
      <StyledTableHeadingCell width="10%">
        {t("expenseType")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="10%">
        {t("common:description")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="6%">
        {t("common:date")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="4%">{t("amount")}</StyledTableHeadingCell>
      <StyledTableHeadingCell width="4%">
        {t("unitPrice")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="4%">
        {t("common:unit")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="5%">
        {t("payslipLong")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="4%">
        {t("repeatingRow")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="6%">
        {t("repeatsUntil")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="10%">{t("target")}</StyledTableHeadingCell>
      <StyledTableHeadingCell width="7%">
        {t("costCenter")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell textAlign="center" width="4%">
        {t("billable")}
      </StyledTableHeadingCell>
      <StyledTableHeadingCell width="2%" />
    </TableRow>
  );
};
